import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalSearchService {

  constructor() { }

  public static search(objectArray: Object[], query) {
    if(objectArray.length == 0)
      return [];
    if(!query)
      return objectArray;
    query = query.toLowerCase();
    const columns = Object.keys(objectArray[0]);
    if (!columns.length) {
      return [];
    }
    const rows = objectArray.filter(function(d) {
      for (let i = 0; i <= columns.length; i++) {
        const column = columns[i];
        if (d[column] && d[column].toString().toLowerCase().indexOf(query) > -1) {
          return true;
        }
      }
    });
    return rows;
  }
}
